module.exports = __webpack_public_path__ + "img/stageIcon.5e8c085b.svg";